import React from "react";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";

import imgH from "../../assets/ecom/phone.png";
import imgHPattern from "../../assets/image/l6/png/l6-hero-pattern.png";
import imgHW from "../../assets/image/svg/l6-hero-wave.svg";
import imgHWD from "../../assets/image/svg/l6-hero-wave-dark.svg";
import imgS1 from "../../assets/image/l6/png/l6-hero-shape1.png";
import imgS2 from "../../assets/image/l6/png/l6-hero-shape2.png";
import imgS3 from "../../assets/image/l6/png/l6-hero-shape3.png";
import imgAS from "../../assets/image/l6/png/l6-download-appstore.png";
import imgGP from "../../assets/image/l6/png/l6-download-gplay.png";

const Hero = ({data}) => {
  return (
    <>
      {/* <!-- Hero Area --> */}
      <div
        className="hero-area-03 pt-29 pt-lg-32 pb-5 position-relative "
        css={`
          background-image: linear-gradient(
            225deg,
            #7b11f9 0%,
            #7922d8 39%,
            #3636b2 100%
          );
        `}
      >
        <div
          className="shape-1 gr-abs-tl"
          data-aos="fade-down-right"
          data-aos-duration="500"
          data-aos-delay="500"
        >
          <img src={imgS1} alt="" />
        </div>
        <div
          className="shape-2 gr-abs-tl"
          data-aos="fade-down-right"
          data-aos-duration="800"
          data-aos-delay="800"
        >
          <img src={imgS2} alt="" />
        </div>
        <div
          className="shape-3 gr-abs-tl"
          data-aos="fade-down-right"
          data-aos-duration="1100"
          data-aos-delay="1100"
        >
          <img src={imgS3} alt="" />
        </div>
        <Container>
          <Row className="justify-content-center">
            <Col md="9" lg="7" xl="6">
              <div className="hero-content dark-mode-texts mb-15 mb-lg-30 text-center text-md-left ">
                <h1 className="gr-text-2 mb-8 text-white">
                  {data.hero_text.text}
                </h1>
                <p className="gr-text-8 px-7 pl-md-0 pr-md-11 mb-0 gr-color-white-opacity-7 d-none d-md-inline-block">
    
                  {data.hero_sub_text.text}
                  {" "}
                </p>
                <div className="hero-btns mt-11">
                  <Link
                    to="/#enquire-now"
                    className="btn rounded-8 gr-hover-y btn-top btn_green"
                  >
                    {data.cta_button_text.text}
                  </Link>
                </div>
              </div>
            </Col>
            <div
              className="col-md-9 col-lg-5 col-xl-6"
              data-aos="fade-up"
              data-aos-duration="2000"
              data-aos-delay="500"
            >
              <div className="hero-img position-relative text-center">
                <img
                  src={data.hero_image.url}
                  alt=""
                  className="position-relative gr-z-index-1 d-none d-md-inline-block"
                  width="450px"
                />
                <div
                  className="abs-img"
                  data-aos="zoom-in"
                  data-aos-delay="2100"
                  data-aos-duration="800"
                  css={`
                    z-index: initial;
                  `}
                >
                  <img src={imgHPattern} alt="" />
                </div>
              </div>
            </div>
          </Row>
        </Container>
        <div className="wave-shape">
          <img src={imgHW} alt="" className="w-100 light-shape default-shape" />
          <img src={imgHWD} alt="" className="w-100 dark-shape" />
        </div>
      </div>
    </>
  );
};

export default Hero;
